import { vModelText as _vModelText, withKeys as _withKeys, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "form-inline" }
const _hoisted_2 = ["maxlength"]
const _hoisted_3 = { class: "btn-wrap" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createElementVNode("input", {
      id: "searchInput",
      type: "text",
      placeholder: "Search",
      style: {"min-width":"50%"},
      class: "searchForm form-control form-control-sm",
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchForm) = $event)),
      onKeyup: _cache[1] || (_cache[1] = _withKeys(
//@ts-ignore
(...args) => (_ctx.onChangeForm && _ctx.onChangeForm(...args)), ["enter"])),
      maxlength: _ctx.$root.const.profileLocationMaxLen + _ctx.$root.const.publicPageTitleMaxLen
    }, null, 40, _hoisted_2), [
      [_vModelText, _ctx.searchForm]
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("button", {
        type: "button",
        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onChangeForm && _ctx.onChangeForm(...args))),
        class: "btn btn-outline-primary btn-sm",
        style: {"margin":"4px"}
      }, "検索")
    ])
  ]))
}